import './styles.scss';

import { Link } from '@ets-global/b2c-website-ui';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import InjectHtml from '../../InjectHtml';

const BorderedBox = ({ small = false, animated = false, title, color, linkTo, children }) => {
  return (
    <div
      className={classNames('bordered-box', small && 'bordered-box--small', animated && 'bordered-box--animated')}
      style={{
        borderColor: color,
      }}
    >
      {linkTo ? (
        <Fragment>
          <Link to={linkTo} aria-label={title}>
            <InjectHtml className="bordered-box__title" style={{ color }} component={'h2'} html={title} />
          </Link>
          <Link className="bordered-box__content" to={linkTo} aria-label={`link to ${linkTo}`}>
            {children}
          </Link>
        </Fragment>
      ) : (
        <Fragment>
          <InjectHtml component={'h2'} className="bordered-box__title" style={{ color }} html={title} />
          <div className="bordered-box__content">{children}</div>
        </Fragment>
      )}
    </div>
  );
};

BorderedBox.propType = {
  small: PropTypes.bool,
  animated: PropTypes.bool,
  title: PropTypes.string,
  color: PropTypes.string,
  linkTo: PropTypes.string,
  children: PropTypes.any,
};

export default BorderedBox;
